const shareConstants = {
  TOGGLE_SHARE: "TOGGLE_SHARE",
}

export default shareConstants
